export default __webpack_public_path__ + "static/2407-ead6a5fd05d697b4c84a6fbd6e4f7ea4.jpeg";